import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ReactionLikeIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps({ ...props, viewBox: "0 0 28 28" })}>
    <rect fill="#33AB6F" height="28" rx="14" width="28" />
    <path
      clipRule="evenodd"
      d="M14 3.5C8.201 3.5 3.5 8.201 3.5 14C3.5 19.799 8.201 24.5 14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.201 19.799 3.5 14 3.5Z"
      fill="white"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M20.3844 18.1343C19.4731 19.0501 17.4324 20.5876 14.0004 20.5876C10.5676 20.5876 8.52685 19.0501 7.6156 18.1343C7.24285 17.7586 7.24435 17.1518 7.6201 16.7791C7.9951 16.4056 8.60185 16.4071 8.97535 16.7828C9.83185 17.6438 11.3986 18.6706 14.0004 18.6706C16.6021 18.6706 18.1689 17.6438 19.0254 16.7828C19.3981 16.4071 20.0049 16.4056 20.3806 16.7791C20.7556 17.1518 20.7579 17.7586 20.3844 18.1343Z"
      fill="#298959"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M10.688 10C11.7237 10 12.5637 10.8392 12.5637 11.875C12.5637 12.9107 11.7237 13.75 10.688 13.75C9.65297 13.75 8.81372 12.9107 8.81372 11.875C8.81372 10.8392 9.65297 10 10.688 10Z"
      fill="#298959"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M17.4385 10C18.4742 10 19.3142 10.8392 19.3142 11.875C19.3142 12.9107 18.4742 13.75 17.4385 13.75C16.4035 13.75 15.5642 12.9107 15.5642 11.875C15.5642 10.8392 16.4035 10 17.4385 10Z"
      fill="#298959"
      fillRule="evenodd"
    />
  </svg>
);
